<script>
    export default {
        methods: {
            createDynamicAddressbarUrl() {
                console.log('createDynamicUrl');

                // const store = useStore();
                let Filters = this.$store.state.Filters
                let pageNumber = this.$store.state.page;

                let slugs = [];

                Filters.forEach((filterItem, index) => {
                    if (filterItem.values.length > 0) {
                        filterItem.values.forEach((value, index) => {
                            slugs.push(value.slug);
                        });
                    }
                });

                let fullUrl = window.location.origin;
                fullUrl += /inspiraties/;

                // Don't execute on page load
                if (this.$store.state.initialPageLoad === false) {

                    if (slugs.length > 0) {
                        let fullSlug = slugs.join('/');
                        fullUrl += fullSlug;
                        fullUrl += '/';
                    }

                    if (pageNumber !== 1) {
                        fullUrl += 'page-'+pageNumber;
                        fullUrl += '/';
                    }

                    window.history.pushState(fullUrl, "Inspiratie", fullUrl);
                }
            }
        }
    };
</script>